import { ConsistencyDashboard } from './ConsistencyDashboard'

export default function IndexConsistency() {
  return <ConsistencyDashboard />
}


